import React from 'react';
import './InterviewQuestionItem.css';
import PostContent from './PostContent';

const InterviewQuestionItem = ({ question, index }) => {

  return (

    <li className="accordion-item">
      <span className="accordion-title">
        <span>{index}. {question.question}</span>

        {question.iscode && (
          <span className="right-one">
            <i className="bx bx-code-block bg-transparent"></i>
          </span>
        )}

        <span className={`right level-tag ${question.levelname.toLowerCase()}`}>
          {question.levelname}
        </span>
      </span>

      <div className="accordion-content show">
        <PostContent html={question.answer} className="answer-text dropcap-paragraph" />
      </div>
    </li>
  );
};

export default InterviewQuestionItem;